exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tooltipContainer-3vpTU{position:relative}.tooltipTrigger-2HGsa{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.tooltip-2bE3L{position:absolute;pointer-events:none;z-index:1;padding:12px;border-radius:4px;background-color:#fff;-webkit-box-shadow:0 4px 12px 0 #202046;box-shadow:0 4px 12px 0 #202046;color:#3d3d41;font-size:.8rem;-webkit-animation:fadeIn-1kS1k .5s;animation:fadeIn-1kS1k .5s}.tooltip-2bE3L:after{position:absolute;left:2px;border-width:6px;border-style:solid;content:\"\"}.tooltip-2bE3L.top-3xewZ:after{bottom:-12px;border-color:#fff rgba(0,0,0,0) rgba(0,0,0,0) rgba(0,0,0,0)}.tooltip-2bE3L.bottom-3tc87:after{top:-12px;border-color:rgba(0,0,0,0) rgba(0,0,0,0) #fff rgba(0,0,0,0)}@-webkit-keyframes fadeIn-1kS1k{0%{opacity:0}100%{opacity:1}}@keyframes fadeIn-1kS1k{0%{opacity:0}100%{opacity:1}}", ""]);

// exports
exports.locals = {
	"tooltipContainer": "tooltipContainer-3vpTU",
	"tooltipTrigger": "tooltipTrigger-2HGsa",
	"tooltip": "tooltip-2bE3L",
	"fadeIn": "fadeIn-1kS1k",
	"top": "top-3xewZ",
	"bottom": "bottom-3tc87"
};